import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { navLinks } from '../mock';

const Footer = () => {
  const { theme } = useTheme();
  return (
    <footer
      className="transition-colors duration-500"
      style={{
        background: theme.sectionAlt,
        color: theme.bodyText,
        borderTop: `1px solid ${theme.cardBorder}`,
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img
              src={theme.logo}
              alt="SVF crest"
              className="w-14 h-14 object-contain"
              style={{ filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.4))' }}
            />
            <div className="font-serif text-sm tracking-[0.18em]" style={{ color: theme.brand }}>
              SAGI VENKATA NARASIMHAM FOUNDATION
            </div>
          </div>
          <p className="text-sm leading-relaxed" style={{ color: theme.muted }}>
            Preserving, researching, and propagating Indic cultures, languages, philosophy & identity for future generations.
          </p>
        </div>

        <div>
          <h4 className="font-serif tracking-[0.18em] text-sm mb-4" style={{ color: theme.brand }}>EXPLORE</h4>
          <ul className="space-y-2">
            {navLinks.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-sm hover:underline transition-colors" style={{ color: theme.bodyText }}>
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-serif tracking-[0.18em] text-sm mb-4" style={{ color: theme.brand }}>SAMVAD</h4>
          <p className="text-sm" style={{ color: theme.muted }}>
            For collaborations, scholarships, and academic enquiries,<br />write to us at <span style={{ color: theme.brand }}>samvad@svfoundation.org</span>
          </p>
        </div>
      </div>
      <div
        className="text-center py-5 text-xs tracking-wider"
        style={{ borderTop: `1px solid ${theme.cardBorder}`, color: theme.muted }}
      >
        © {new Date().getFullYear()} Sagi Venkata Narasimham Foundation. Sa Vidya Ya Vimuktaye.
      </div>
    </footer>
  );
};

export default Footer;
